import { memo } from 'react';
import styled from '@emotion/styled';
import { ChatMarkdown } from '@trinity/chat-components/components/Markdown/Markdown.js';
import { SeeMore, Expander, Collapser } from '@trinity/chat-components/components/presentation/SeeMore';
import { MessageCitationMaybeLink } from './Citation.MaybeLink';

type Props = {
  className?: string;
  content: string;
  maxLines?: number;
  baseUrl?: string;
  to: string;
};

export const MessageCitationSnippet = memo(({ baseUrl, className, content, to, maxLines = 20 }: Props) => {
  return (
    <SnippetRoot className={className}>
      <Wrap>
        <SeeMore
          ExpanderComp={SeeMoreExpander}
          CollapserComp={SeeMoreCollapser}
          lineHeight={SnippetLineHeight}
          maxLines={maxLines}>
          <SnippetText>
            <ChatMarkdown value={content} />
          </SnippetText>
        </SeeMore>
        {!!to && (
          <Footer>
            <MessageCitationMaybeLink to={to} baseUrl={baseUrl}>
              <View>{`View >`}</View>
            </MessageCitationMaybeLink>
          </Footer>
        )}
      </Wrap>
    </SnippetRoot>
  );
});

const SnippetLineHeight = 18;

export const SnippetRoot = styled.div`
  line-height: ${SnippetLineHeight}px;
  box-sizing: border-box;
  background-color: ${props => props.theme.palette.gray.light3};
  padding: 12px;
`;

const Wrap = styled.div`
`;

export const SnippetText = styled.div`
  white-space: pre-wrap;
  font-family: ${props => props.theme.fonts.regular};
  font-size: 14px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

const View = styled.div`
  font-size: 13px;
  font-family: ${props => props.theme.fonts.semiBold};
`;

const SeeMoreExpander = styled(Expander)`
  background-color: ${props => props.theme.palette.gray.light3} !important;
`;

const SeeMoreCollapser = styled(Collapser)`
  background-color: ${props => props.theme.palette.gray.light3} !important;
`;
